import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ENTERPRISE_MODULE3_IMPORT_PLATFORMS_OPTIONS } from "../../../../utils/constants";
import {
  ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT,
  ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS,
  ENTERPRISE_INTAKE_MODULE3_INTRO,
} from "../../../../i18n/keysTranslations";
import ReadOnlySectionGrid from "../../../PreActivation/components/ReadOnlySectionGrid";
import CheckboxGroupWithOtherField from "../shared/CheckboxGroupWithOtherField";
import ModuleSectionIntro from "../shared/ModuleSectionIntro";
import NumericFieldBlock from "../shared/NumericFieldBlock";
import { mapTranslatedOptions } from "../shared/mapTranslatedOptions";

const Module3PaidMediaImportSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const importPlatformOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_MODULE3_IMPORT_PLATFORMS_OPTIONS,
        t,
      }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      {!readOnly ? (
        <ModuleSectionIntro introKey={ENTERPRISE_INTAKE_MODULE3_INTRO} />
      ) : null}

      <NumericFieldBlock
        name="module3CampaignsToImportCount"
        labelKey={ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <CheckboxGroupWithOtherField
        name="module3ImportPlatforms"
        otherName="module3ImportPlatformsOther"
        labelKey={ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS}
        required
        options={importPlatformOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
    </ReadOnlySectionGrid>
  );
};

export default Module3PaidMediaImportSection;
